import { any, func, bool, object, arrayOf, shape, string } from "prop-types";
import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import ReadingStatus from "../ReadingListDownload/reading_status";
import { getABMForm } from "../../api/profileApi";
import OnboardingArea from "../../common/OnboardingSectionCreator";
import Spinner from "../../common/Spinner";
import Button from "../../common/Button";
import { submitABMForm } from "../../redux/actions";
import * as styles from "../../common/OnboardingSectionCreator/styles.module.scss";
import * as style from "../ReadingListDownload/styles.module.scss";

const AbmOnboarding = ({ appData, submitABMFormsFunc }) => {
  const { abmOnboarding } = { ...{ abmOnboarding: {} }, ...appData };

  const [loading, setLoading] = useState(false);

  const submitted = abmOnboarding && abmOnboarding.submitted;

  useEffect(() => {
    setLoading(false);
  }, [submitted]);

  const formsListWithStatus = [
    {
      status:
        abmOnboarding.submitted || abmOnboarding.personalInfo
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      submitted,
      title: "Personal Information",
      url: `/profile/edit/ABM-onboarding/personal-information`,
    },
    {
      status:
        abmOnboarding.submitted || abmOnboarding.workhistory
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      submitted,
      title: "Five Year Work History",
      url: `/profile/edit/ABM-onboarding/work-history`,
    },
    {
      status:
        abmOnboarding.submitted || abmOnboarding.declarations
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      submitted,
      title: "Declarations",
      url: `/profile/edit/ABM-onboarding/declarations`,
    },
    {
      status:
        abmOnboarding.submitted || abmOnboarding.consent
          ? ReadingStatus.Done
          : ReadingStatus.Todo,
      title: "Consent",
      submitted,
      url: `/profile/edit/ABM-onboarding/consent`,
    },
  ];

  const leftColumnComponents = [
    {
      title: "ABM Onboarding Forms",
      subtext: `Please complete all of the below forms. Once you have completed
      all forms, please click on the Submit button to finish your
      onboarding process. Once you have submitted your forms you will be
      unable to edit them. If you have any queries about the forms,
      please speak to your HRGO Consultant.`,
      formsListWithStatus,
      hasSignatureUpload: true,
      imageFileKey: "abmDeclaration",
    },
  ];

  const handleSubmit = () => {
    setLoading(true);
    const { declarations, consent, personalInfo, workhistory } =
      appData.abmOnboarding;
    submitABMFormsFunc({
      declarations,
      consent,
      personalInfo,
      workhistory,
    });
  };

  const triggerDownload = () => {
    setLoading(true);
    getABMForm().then((response) => {
      const link = document.createElement("a");
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });
      link.href = window.URL.createObjectURL(blob);
      link.download = `ABM_Onboarding_Form.pdf`;
      link.click();
      setLoading(false);
    });
  };

  const canSubmit = formsListWithStatus.every(
    (doc) => doc.status === ReadingStatus.Done
  );

  const submitRow = () => {
    return (
      <div className={style.buttonContainer}>
        {!submitted ? (
          <Fragment>
            <div className={styles.submitButtonDesktop}>
              Please click on the Submit button for your forms to be sent to HR
              GO.
            </div>
            <Button
              classes={`btn btn-primary ${style.buttonSubmit}`}
              onClick={handleSubmit}
              disabled={canSubmit && !loading ? "" : "disabled"}
            >
              {loading ? (
                <Fragment>
                  Submit <Spinner />
                </Fragment>
              ) : (
                "Submit"
              )}
            </Button>
          </Fragment>
        ) : (
          <button
            className="btn btn-primary"
            onClick={triggerDownload}
            disabled={loading ? "disabled" : ""}
          >
            {loading ? (
              <Fragment>
                Download Form <Spinner />
              </Fragment>
            ) : (
              "Download Form"
            )}
          </button>
        )}
      </div>
    );
  };

  return (
    <OnboardingArea
      title="ABM Onboarding"
      leftColumnComponents={leftColumnComponents}
      rightColumnComponents={[]}
      leftSubmit={submitRow}
      hasDBS={true}
      dbsURL="https://forms.office.com/Pages/ResponsePage.aspx?id=bF43RFTuvUGKgS0U9GKUztDCA2HJiIpHsdJGOi34cPhUNzIxS0lXRDNQQzRNSlY5OEpPNEJFSFE0SiQlQCN0PWcu"
    />
  );
};

AbmOnboarding.propTypes = {
  appData: any,
  submitABMFormsFunc: func,
  readingList: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  abmOnboarding: object,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  abmOnboarding: state.core.app.abmOnboarding,
});

const mapDispatchToProps = {
  submitABMFormsFunc: submitABMForm,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(AbmOnboarding);
